import mutations from './pubHealthCareCert.mutations'
import actions from './pubHealthCareCert.actions'
import getters from './pubHealthCareCert.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
